<template>
  <div class="content">
    <div class="navcontainer _navcontainer">
      <div class="appleicon _appleicon" @click="goRouter('/home')">
        <img src="~@/assets/images/home/logo.png" />
      </div>
      <div class="navicon _navicon">
        <img
          src="~@/assets/images/home/mmeun.png"
          class="m_img"
          @click="opencaidan()"
        />
      </div>
      <div id="navID" class="mainnavlist _mainnavlist">
        <div class="navlistclose">
          <i @click="closecaidan()" class="iconfont icon-guanbi"></i>
        </div>
        <div
          class="nav_item"
          :class="{ active: isCurrent(item.path) }"
          v-for="item in navList"
          :key="item.id"
          @click="goRouter(item.path)"
        >
          {{ $store.state.chinese ? item.name : item.en_name }}
        </div>
        <div class="nav_item" @click="change()">CN/EN</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navtop",
  components: {},
  data() {
    return {
      nalistshowflag: false,
      navList: [
        {
          name: "首页",
          en_name: "Home",
          path: "/home",
          id: 1,
        },
        {
          name: "品牌",
          en_name: "Brand",
          path: "/story",
          id: 2,
        },
        {
          name: "内容",
          en_name: "Content",
          path: "/explore",
          id: 4,
        },
        {
          name: "业务",
          en_name: "Business",
          path: "/shareadv",
          id: 3,
        },
        {
          name: "一起探险",
          en_name: "Join Us",
          path: "/together-expedition",
          id: 5,
        },
      ],
    };
  },
  methods: {
    routerpush(to) {
      this.$router.push(to);
      // 跳转之后，记得关闭菜单（在屏幕宽度小于768的时候才生效）
      var dom = document.getElementById("navID");
      if (dom.classList.contains("navlistshow")) {
        dom.classList.remove("navlistshow");
      }
    },
    // 当屏幕宽度小于768时候，点击菜单图标，显示隐藏的菜单
    opencaidan() {
      var dom = document.getElementById("navID");

      if (dom.classList.contains("navlistshow")) {
        return;
      }
      dom.classList.add("navlistshow");
    },
    // 当屏幕宽度小于768的时候，点击关闭按钮， 关闭菜单
    closecaidan() {
      var dom = document.getElementById("navID");
      if (dom.classList.contains("navlistshow")) {
        dom.classList.remove("navlistshow");
      }
    },
    // 路由跳转
    goRouter(path) {
      this.closecaidan();
      this.$router.push(path);
    },
    // 判断路由激活状态
    isCurrent(path) {
      if (this.$route.path == path) {
        return true;
      } else {
        return false;
      }
    },
    // 切换语言
    change() {
      this.closecaidan();
      this.$store.commit("changeLang");
    },
  },
};
</script>

<style lang="less" scoped>
// 大于768px
@media only screen and (min-width: 768px) {
  .content {
    background: #f0f2f5;
    width: 100%;
    min-width: 1200px;
    margin-bottom: 60px;
  }
  .navcontainer {
    width: 80%;
    margin: 0 auto;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    color: rgb(214, 214, 214);
    .navicon {
      display: none;
      cursor: pointer;
    }
    .navicon:hover {
      color: white;
    }
    .appleicon {
      width: 100px;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .appleicon:hover {
      color: white;
    }
    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 80px;
      .nav_item {
        height: 100%;
        line-height: 80px;
        font-size: 16px;
        font-family:'PingFang SC','Microsoft YaHei';
        font-weight: 400;
        color: #1a213f;
        cursor: pointer;
      }
      .navlistclose {
        display: none;
      }
      div {
        text-align: center;
        height: 40px;
        font-family:'PingFang SC','Microsoft YaHei';
        line-height: 40px;
        padding: 0 40px ;
        // width: 120px;
      }
      div:hover {
        // font-size: 16px;
        // font-weight: bold;
        color: #004993;
        border-bottom: 4px solid #004993;
      }
      .active {
        color: #004993;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .content {
    position: sticky;
    top: 0;
    z-index: 2000;
    background: #f0f2f5;
    width: 100%;
  }
  ._navcontainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    color: rgb(214, 214, 214);
    ._navicon {
      width: 100px;
      .m_img {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
    }
    ._appleicon {
      width: 24%;
      height: 80%;
      padding-left: 20px;
      img {
        width: 100%;
        height: 100%;
      }
      cursor: pointer;
    }
    ._mainnavlist {
      display: none;
      position: fixed;
      right: 0;
      top: 40px !important;
      z-index: 1999 !important;
      padding-top: 20px !important;
      width: 40%;
      height: 100%;
      color: rgb(214, 214, 214);
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      top: 40px;
      padding: 0 15px;
      z-index: 999;
      background: #0f1e3d;
      opacity: 0.8;
      .icon-guanbi {
        float: right;
      }
      div {
        text-align: left;
        height: 46px;
        font-size: 16px;
        line-height: 46px;
        width: 100%;
      }
    }
  }
  .navlistshow {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/NavTop.vue